import React from "react";
import "./forecastDay.css";

export default function ForecastDay(props) {
  function day() {
    let date = new Date(props.info.time * 1000);
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let day = days[date.getDay()];
    return day;
  }
  return (
    <div>
      <div className="forecast-day">{day()}</div>
      <img
        className="icon"
        src={props.info.condition.icon_url}
        alt={props.info.condition.description}
      />
      <div className="forecast-temp-">
        <span className="forecast-temp-max">
          {Math.round(props.info.temperature.maximum)}º
        </span>
        <span className="forecast-temp-min">
          {Math.round(props.info.temperature.minimum)}º
        </span>
      </div>
    </div>
  );
}
